module.exports = __webpack_public_path__ + "59e5b588d1c490bc2921cbf308e1c7d3.pdf";